<!-- 增改商品 -->
<template>
  <div>
    <el-dialog
      :width="popupWidth"
      :title="popupTitle"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="popup-main">
        <div v-if="selfData.lei_mu_lei_xing === '原料'" class="mu-ban-category">
          <div class="flex flex-y-center">
            <span class="m-r-5 c-red">*</span>
            <span class="m-r-5 c-black">商品模板</span>
          </div>
          <el-select
            v-model="selfData.mu_ban_id"
            :disabled="!!this.detailId"
            size="mini"
            class="flex-1"
            filterable
          >
            <el-option label="" value="" disabled>
              <el-link
                type="success"
                style="display: block"
                :underline="false"
                @click="popupMoBanDo"
              >
                新增模板
              </el-link>
            </el-option>
            <el-option
              v-for="(item, index) in muBanList"
              :key="index"
              :value="item.id"
              :label="item.mu_ban_ming_cheng"
            />
          </el-select>
        </div>
        <div v-else class="mu-ban-category">
          <div>
            <span class="m-r-5 c-black">商品类目</span>
          </div>
          <b-goods-texture
            v-if="loaded"
            :data.sync="categoryTextureData"
            :categoryTextureStr="categoryTextureStr"
            width="938px"
          />
        </div>
        <component
          v-if="loaded"
          :is="componentData[selfData.lei_mu_lei_xing]"
          :data.sync="selfData"
          :disabled="disabled"
          @setUnit="setUnit"
          @wuLiaoChooseOne="wuLiaoChooseOne"
          @wuLiaoChooseMore="wuLiaoChooseMore"
          @jiaGongChooseMore="jiaGongChooseMore"
          @jiaGongInputOne="jiaGongInputOne"
          @wuLiaoDetail="popupWuLiaoDetail"
          @jiaGongDetail="popupJiaGongDetail"
        />
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">{{ disabled ? '关闭' : '取消' }}</el-button>
        <el-button v-if="!disabled" size="mini" type="primary" @click="popupConfirm">
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-增改商品 -->
    <PopupDoShangPin
      v-if="isShowPopupDoShangPin"
      :show.sync="isShowPopupDoShangPin"
      :detailType="wuLiaoDetailType"
      :detailId="wuLiaoDetailId"
      disabled
    />

    <!-- 弹窗-增改模板 -->
    <PopupDoMuBan
      v-if="isShowPopupDoMuBan"
      :show.sync="isShowPopupDoMuBan"
      :detailId="jiaGongDetailId"
      :bao_han="jiaGongDetailId ? ['加工'] : ['原料', '零件', '组装']"
      :disabled="!!jiaGongDetailId"
      @success="getMuBanListData"
    />

    <!-- 弹窗-设置单位 -->
    <PopupSetUnit v-if="isShowPopupSetUnit" :show.sync="isShowPopupSetUnit" :data.sync="selfData" />

    <!-- 弹窗-选择单个物料 -->
    <PopupWuLiaoChooseOne
      v-if="isShowPopupWuLiaoChooseOne"
      :show.sync="isShowPopupWuLiaoChooseOne"
      :isLingJian="selfData.lei_mu_lei_xing === '零件'"
      @success="wuLiaoChooseOneSuccess"
    />

    <!-- 弹窗-选择多个物料 -->
    <PopupWuLiaoChooseMore
      v-if="isShowPopupWuLiaoChooseMore"
      :show.sync="isShowPopupWuLiaoChooseMore"
      @success="wuLiaoChooseMoreSuccess"
    />

    <!-- 弹窗-选择多个加工 -->
    <PopupJiaGongChooseMore
      v-if="isShowPopupJiaGongChooseMore"
      :show.sync="isShowPopupJiaGongChooseMore"
      :gui_ge_shi_li="shangPinGuiGe"
      :dan_wei="shangPinDanWei"
      :dan_jian_shu_liang="shangPinShuLiang"
      :mu_ban_id="selfData.wu_liao_choose_list[0].mu_ban_id"
      @success="jiaGongChooseMoreSuccess"
    />

    <!-- 弹窗-录入单个加工 -->
    <PopupJiaGongInputOne
      v-if="isShowPopupJiaGongInputOne"
      :show.sync="isShowPopupJiaGongInputOne"
      :index="activeJiaGongIndex"
      :list="selfData.jia_gong_choose_list"
      :gui_ge_shi_li="shangPinGuiGe"
      :dan_wei="shangPinDanWei"
      :dan_jian_shu_liang="shangPinShuLiang"
      @success="jiaGongInputOneSuccess"
    />
  </div>
</template>

<script>
export default {
  name: 'PopupDoShangPin',
  components: {
    ShangPinYuanLiao: () => import('./shang-pin-yuan-liao'),
    ShangPinLingJian: () => import('./shang-pin-ling-jian'),
    ShangPinZuZhuang: () => import('./shang-pin-zu-zhuang'),
    ShangPinWaiGou: () => import('./shang-pin-wai-gou'),
    PopupDoMuBan: () => import('../../mu-ban/common/popup-do-mu-ban'),
    PopupSetUnit: () => import('./popup-set-unit'),
    PopupWuLiaoChooseOne: () => import('./popup-wu-liao-choose-one'),
    PopupWuLiaoChooseMore: () => import('./popup-wu-liao-choose-more'),
    PopupJiaGongChooseMore: () => import('./popup-jia-gong-choose-more'),
    PopupJiaGongInputOne: () => import('./popup-jia-gong-input-one')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    detailType: {
      type: String,
      required: true
    },
    detailId: {
      type: [Number, String],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      selfShow: false,
      selfData: this.$util.deepCopy(this.$constant.muBanShangPinDefaultData),
      componentData: {
        原料: 'ShangPinYuanLiao',
        零件: 'ShangPinLingJian',
        组装: 'ShangPinZuZhuang',
        商品: 'ShangPinWaiGou'
      },
      categoryTextureStr: '',
      categoryTextureData: {},
      muBanList: [],
      isShowPopupDoShangPin: false,
      isShowPopupDoMuBan: false,
      isShowPopupSetUnit: false,
      isShowPopupWuLiaoChooseOne: false,
      isShowPopupWuLiaoChooseMore: false,
      isShowPopupJiaGongChooseMore: false,
      isShowPopupJiaGongInputOne: false,
      activeJiaGongIndex: '',
      wuLiaoDetailType: '',
      wuLiaoDetailId: '',
      jiaGongDetailId: ''
    }
  },
  computed: {
    popupWidth() {
      return this.detailType === '原料' || this.detailType === '商品' ? '1032px' : '1880px'
    },
    popupTitle() {
      let result = this.detailId ? '编辑' : '新增'
      if (this.detailType === '原料') {
        result += '自建商品'
      } else if (this.detailType === '商品') {
        result += '其他商品'
      } else {
        result += this.detailType
      }
      return result
    },
    // 商品规格
    shangPinGuiGe() {
      return this.getShangPinCustomFieldVal('规格')
    },
    // 商品单位
    shangPinDanWei() {
      return this.getShangPinCustomFieldVal('单位')
    },
    // 商品单件数量
    shangPinShuLiang() {
      return this.getShangPinCustomFieldVal('单件数量')
    },
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      if (this.detailId) {
        result = this.selfData.lei_mu_name
      } else {
        let listName = []
        listName = this.categoryTextureData.category_list.map((item) => {
          return item.name
        }) // 类目
        if (this.categoryTextureData.texture_data.key) {
          listName.push(this.categoryTextureData.texture_data.key) // 材质
        }
        result = listName.join('/')
      }

      return result // 类目材质拼接成字符串
    },
    // 类目类型
    activeCategoryType() {
      let result = ''
      if (this.detailId) {
        result = this.selfData.lei_mu_lei_xing
      } else {
        if (this.categoryTextureData && this.categoryTextureData.category_list) {
          let len = this.categoryTextureData.category_list.length
          if (len) result = this.categoryTextureData.category_list[len - 1].lei_mu_lei_xing
        }
      }
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    },
    // 类目材质数据
    categoryTextureData: {
      handler(val) {
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          if (val.category_list && val.category_list.length) {
            this.selfData.lei_mu_data = this.$util.deepCopy(val)
          }
          if (!this.detailId && val.texture_data) this.selfData.mi_du_shi_li = val.texture_data.val
          this.timer = null
        }, 500)
      },
      deep: true,
      immediate: true
    },
    // 监听-商品模板列表
    muBanList: {
      handler(val) {
        if (!this.selfData.mu_ban_id) this.selfData.mu_ban_id = val.length ? val[0].id : ''
      },
      deep: true,
      immediate: true
    },
    'selfData.mu_ban_id': {
      handler(newVal, oldVal) {
        if (!this.detailId && newVal && newVal !== oldVal) this.getMuBanDetailData()
      },
      deep: true,
      immediate: true
    },
    'selfData.dan_wei_zu_list': {
      handler(val) {
        let result = []

        val.forEach((itemSt) => {
          itemSt.dan_wei_list.forEach((itemNd) => {
            // 存储默认单位
            if (itemNd.is_mo_ren_dan_wei) {
              this.selfData.mo_ren_dan_wei_zu = `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
            }

            // 下拉单位数据
            result.push({
              key: `${itemNd.dan_wei_name}`,
              val: `${itemNd.dan_wei_name},${itemSt.dan_wei_zu_name}`
            })
          })
        })
        this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
          if (item.name === '单位') {
            item.set_options = result
            if (!item.value && result.length) {
              item.value = result[0].val
            }
            return
          }
        })
      },
      deep: true,
      immediate: true
    },
    'selfData.lei_mu_lei_xing': {
      handler(val) {
        if (val === '商品' || val === '组装') {
          if (!this.selfData.dan_wei_zu_list.length) {
            this.selfData.dan_wei_zu_list = this.$util.deepCopy(
              this.$constant.shangPinMuBanUnitListZuZhuang
            )
          }
        }
      },
      deep: true,
      immediate: true
    },
    // 商品规格
    shangPinGuiGe(val) {
      this.setJiaGongFieldVal('gui_ge_shi_li', val)
    },
    // 商品单位
    shangPinDanWei(val) {
      this.setJiaGongFieldVal('dan_wei', val)
    },
    // 商品单件数量
    shangPinShuLiang(val) {
      this.setJiaGongFieldVal('dan_jian_shu_liang', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getMuBanListData()
    if (this.detailId) this.getDetailData()
  },
  methods: {
    // 获取商品自定义字段值
    getShangPinCustomFieldVal(field) {
      let result = ''
      if (this.selfData.custom_mo_kuai_list && this.selfData.custom_mo_kuai_list.length) {
        this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
          if (item.name === field) {
            result = item.value
          }
        })
      }
      return result
    },
    // 设置加工字段值
    setJiaGongFieldVal(field, val) {
      if (this.selfData.jia_gong_choose_list) {
        this.selfData.jia_gong_choose_list.forEach((item) => {
          let oldVal = item[field]
          let newVal = val
          item[field] = newVal
          if (field === 'dan_jian_shu_liang') {
            let biLi = this.$XEUtils.divide(oldVal, newVal)
            item.dan_jia = this.$XEUtils.multiply(item.dan_jia, biLi)
          }
        })
      }
    },
    // 获取数据----------------------------------------------
    // 获取模板列表数据
    async getMuBanListData() {
      await this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          bao_han: [this.detailType], // '原料', '零件', '组装'
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.muBanList = res.data.page.list
          }
        })
        .catch(() => {})
    },
    // 获取模板详情数据
    async getMuBanDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/muBan/detail',
        params: {
          id: this.selfData.mu_ban_id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          let mu_ban_id = result.id
          result.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
            if (item.name === '商品名称') item.value = result.mu_ban_ming_cheng
            if (item.name === '商品关键词') item.value = result.mu_ban_guan_jian_ci
            if (item.name === '商品封面') {
              item.value = this.$util.deepCopy(result.mu_ban_feng_mian)
              result.shang_pin_feng_mian = this.$util.deepCopy(result.mu_ban_feng_mian)
            }
          })

          result.wu_liao_choose_list = []
          result.jia_gong_choose_list = []
          result.mu_ban_id = mu_ban_id
          result.id = ''
          this.selfData = result
          this.loaded = true
        }
      })
    },
    // 获取详情数据
    async getDetailData() {
      this.loaded = false
      await this.$api({
        method: 'get',
        url: '/admin/gcvip/products/detail',
        params: {
          id: this.detailId
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data.data)
          result.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
            if (item.name === '商品编码') item.value = result.id
          })
          this.categoryTextureStr = result.lei_mu_name
          this.selfData = result
        }
      })
      this.loaded = true
    },
    // 弹窗-物料详情
    popupWuLiaoDetail(data) {
      this.wuLiaoDetailType = data.lei_mu_lei_xing
      this.wuLiaoDetailId = data.yuan_ben_id
      this.isShowPopupDoShangPin = true
    },
    // 弹窗-加工详情
    popupJiaGongDetail(id) {
      this.jiaGongDetailId = id
      this.isShowPopupDoMuBan = true
    },
    // 弹窗-模板增改
    popupMoBanDo() {
      this.isShowPopupDoMuBan = true
    },
    // 弹窗-设置单位
    setUnit() {
      this.isShowPopupSetUnit = true
    },

    // 选择物料----------------------------------------------
    // 选择单个物料
    wuLiaoChooseOne() {
      this.isShowPopupWuLiaoChooseOne = true
    },
    // 选择单个物料-成功
    wuLiaoChooseOneSuccess(row) {
      row.yuan_ben_id = row.id
      row.id = ''
      this.selfData.wu_liao_choose_list = [row]
      this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((item) => {
        if (item.name === '规格' && !item.value) {
          item.value = row.gui_ge_shi_li
        }
      })
      if (this.selfData.lei_mu_lei_xing === '零件') {
        this.selfData.dan_wei_zu_list = this.$util.deepCopy(row.dan_wei_zu_list)
        this.selfData.mi_du_shi_li = row.mi_du_shi_li
        this.selfData.gui_ge_list = this.$util.deepCopy(row.gui_ge_list)
        this.selfData.fu_jia_can_shu_list = this.$util.deepCopy(row.fu_jia_can_shu_list)
      }
    },
    // 选择多个物料
    wuLiaoChooseMore() {
      this.isShowPopupWuLiaoChooseMore = true
    },
    // 选择多个物料-成功
    wuLiaoChooseMoreSuccess(rows) {
      rows.forEach((row) => {
        row.yuan_ben_id = row.id
        row.id = ''
        this.selfData.wu_liao_choose_list.push(row)
      })
    },

    // 选择加工----------------------------------------------
    // 选择多个加工
    jiaGongChooseMore() {
      this.isShowPopupJiaGongChooseMore = true
    },
    // 选择多个加工-成功
    jiaGongChooseMoreSuccess(rows) {
      rows.forEach((row) => {
        row.yuan_ben_id = row.id
        row.id = ''
        this.selfData.jia_gong_choose_list.push(row)
      })
    },
    // 手动录入加工
    jiaGongInputOne(index) {
      this.activeJiaGongIndex = index
      this.isShowPopupJiaGongInputOne = true
    },
    // 手动录入加工-成功
    jiaGongInputOneSuccess(row) {
      if (this.activeJiaGongIndex === '') {
        this.selfData.jia_gong_choose_list.push(row)
      } else {
        this.selfData.jia_gong_choose_list.splice(this.activeJiaGongIndex, 1, row)
      }
    },

    // 弹窗操作----------------------------------------------
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let updateList = [
        {
          key: '商品名称',
          val: 'shang_pin_ming_cheng'
        },
        {
          key: '商品关键词',
          val: 'shang_pin_guan_jian_ci'
        },
        {
          key: '商品封面',
          val: 'shang_pin_feng_mian'
        },
        {
          key: '规格',
          val: 'gui_ge_shi_li'
        },
        {
          key: '单位',
          val: 'dan_wei'
        },
        {
          key: '单件数量',
          val: 'dan_jian_shu_liang'
        },
        {
          key: '数量',
          val: 'zong_shu_liang'
        },
        {
          key: '单价',
          val: 'dan_jia'
        },
        {
          key: '单件金额',
          val: 'dan_jian_jin_e'
        },
        {
          key: '金额',
          val: 'zong_jin_e'
        }
      ]
      this.selfData.custom_mo_kuai_list[0].list[0].list.forEach((itemSt) => {
        updateList.forEach((itemNd) => {
          if (itemNd.key === itemSt.name) {
            this.selfData[itemNd.val] = this.$util.deepCopy(itemSt.value)
          }
        })
      })
      if (this.selfData.lei_mu_lei_xing === '商品') {
        this.selfData.lei_mu_data = this.$util.deepCopy(this.categoryTextureData)
        this.selfData.lei_mu_name = this.categoryActiveStr
      }
      this.$api({
        method: 'post',
        url: '/admin/gcvip/products/saveOrUpdate',
        data: this.selfData
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.popupCancel()
          this.$emit('success', {
            isAdd: !this.detailId,
            data: res.data.data
          })
          this.$message.success('保存成功')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  .mu-ban-category {
    position: relative;
    z-index: 99;
    display: flex;
    align-items: center;
    width: 100%;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid @colorGrayE;
  }
}
</style>
